<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="inventoryManagerApp.lot.import.balance.mapping.title">Select Mapping</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closed()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="row mb-3">
            <label class="col-6 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.import.balance.mapping.lotUID">
                    Please specify the header for Lot UID
                </label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownLotUID" id="dropdownLotUID" [(ngModel)]="lotUIDMapping" required>
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.import.balance.mapping.newBalance">Please specify the header for New Balance</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownNewBalance" id="dropdownNewBalance" [(ngModel)]="newBalanceMapping" required>
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="storageLocationAbbrLabel" [(ngModel)]="storageLocationAbbrLabelCheck" #storageLocationAbbrLabel>
                    <label class="form-check-label" for="storageLocationAbbrLabel" jhiTranslate="inventoryManagerApp.lot.import.balance.mapping.storageLocationAbbreviation">
                        Please specify the header for Storage Location Abbreviation
                    </label>
                </div>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownLocationAbbreviation" id="dropdownLocationAbbreviation" [(ngModel)]="storageLocationAbbrMapping" [disabled]="!storageLocationAbbrLabel.checked" [required]="storageLocationAbbrLabel.checked">
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="notesLabel" [(ngModel)]="notesLabelCheck" #notesLabel>
                    <label class="form-check-label" for="notesLabel" jhiTranslate="inventoryManagerApp.lot.import.balance.mapping.notes">Please specify the header for Notes</label>
                </div>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownNotes" id="dropdownNotes" [(ngModel)]="notesMapping" [disabled]="!notesLabel.checked" [required]="notesLabel.checked"
                    >
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.back">Back</span>
    </button>
    <button type="button" (click)="proceed(f)" [disabled]="!isLotUIDMapped() || !isNewBalanceMapped()"  class="btn btn-primary" data-test="proceedToImportButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.proceed">Proceed</span>
    </button>
</div>
